import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import './i18n';

import App from './App';

import './assests/styles/index.css';
import './assests/styles/Common.css';

import "@fontsource/open-sans";
import "@fontsource/quicksand";


// CSP Policy for FA icons
import { config as faConfig } from '@fortawesome/fontawesome-svg-core';
import "../node_modules/@fortawesome/fontawesome-svg-core/styles.css";
import { MapProvider } from 'react-map-gl/dist/esm/components/use-map';

import ReactGA from "react-ga4";

if ("REACT_APP_GA_ID" in process.env){
  ReactGA.initialize(process.env.REACT_APP_GA_ID as string);
}

faConfig.autoAddCss = false

const rootElement = document.getElementById('root')
ReactDOM.render(
  <Provider store={store}>
    <MapProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
    </MapProvider>
  </Provider>,
  rootElement
)

// check for auth token in storage



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

